<template>
  <div class="ui segment report-logo-container">
    <img :src="client_logo_url">
  </div>
</template>

<script>
  import Vue from 'vue';
  export default {
    name: 'report-logo',

    data: function() {
      return {
        client_logo_url: null
      };
    },
    mounted: function() {
      var self = this;

      self.$dataStore.json( "report_info.json", function( report_info_data ) {
        self.$dataStore.raw( report_info_data.logo, function(data, url_path) {
          self.client_logo_url = url_path;
        });
      });
    }
  };
</script>

<style lang="sass">
  @import '../../assets/css/widgets/report-logo.scss';
</style>



// WEBPACK FOOTER //
// src/components/widgets/ReportLogo.vue